module.exports = __webpack_public_path__ + "static/media/Fire_safety_training.278a27ef.jpg";